module.exports = __webpack_public_path__ + "img/maps.f02d9373.png";